module.exports = __webpack_public_path__ + "media/customizations/verandaliving/logo-6342e7bf482028f75ed672b6e228b92c.png";